import Spinner from '@/components/primitives/Spinner.jsx';
import PieveSymbol from '@/components/surfaces/PieveSymbol.jsx';

/** One turn of the setup conversation. Pieve's turns sit on the page; the person's sit in a soft bubble. */
const OnboardingMessage = ({ speaker, isPending = false, children }) => {
  const isAssistant = speaker === 'assistant';

  return (
    <li className={`onboarding-message onboarding-message--${isAssistant ? 'assistant' : 'user'}`}>
      {isAssistant && (
        <span className="onboarding-message__avatar">
          <PieveSymbol size={20} label="Pieve" />
        </span>
      )}
      <p className="onboarding-message__text">
        {isPending ? (
          <span className="onboarding-message__pending">
            <Spinner size={14} /> Reading your answer
          </span>
        ) : (
          children
        )}
      </p>
    </li>
  );
};

export default OnboardingMessage;
